import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./bioSection.css";

const text =
  "Driven by a constant need to innovate, I approach every line of code as an opportunity to build something impactful. My unique learning rhythm allows me to be fully immersed in professional challenges, blending technical rigor with a creative mindset. I am eager to channel this energy and my fullstack expertise into your vision, turning complex requirements into seamless digital experiences.";
const characters = text.split("");

const Char = ({ char, index, total, scrollYProgress }) => {
  // On commence à 0.2 au lieu de 0 pour laisser une marge vide au début
  const start = 0.2 + (index / total) * 0.7;
  const end = start + 0.05;

  const opacity = useTransform(scrollYProgress, [start, end], [0.1, 1]);
  const color = useTransform(
    scrollYProgress,
    [start, end],
    ["#333", "#ffffff"],
  );

  return (
    <motion.span style={{ opacity, color }} className="bioWord">
      {char}
    </motion.span>
  );
};

const BioSection = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 0.9", "start 0.2"],
  });

  return (
    <section className="bio" ref={containerRef} id="bio">
      <p className="bioText">
        {characters.map((char, i) => (
          <Char
            key={i}
            char={char}
            index={i}
            total={characters.length}
            scrollYProgress={scrollYProgress}
          />
        ))}
      </p>
    </section>
  );
};

export default BioSection;
